<template>
  <inventoryProductsForm :typeEndPoint="'papeleriaProductsCreate'" :dataParams="{}"/>
</template>
<script>
import inventoryProductsForm from '@/components/modules/papeleria/products/form'
export default {
  name: 'inventoryProductsCreate',
  components: {
    inventoryProductsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/create.vue